export const devConfiguration = {
  getLogin: "/admin/signIn",
  forgotPassword: "/admin/forgetPassword",
  verifyOtp: "/admin/verifyOTP",
  resetPassword: "/admin/resetPassword",
  getCMSoverview: "/admin/getCMS?type=overview",
  getCMSformatview: "/admin/getCMS?type=format_rules",
  updateCMS: "/admin/updateContentManagement",
  addVenue: "/admin/addVenue",
  getVenuelist: "/admin/viewVenueList",
  getVenueById: "/admin/viewVenue",
  updateVenue: "/admin/updateVenue",
  addNews: "/admin/createNews",
  getNewslist: "/admin/newsList",
  updateNewsState: "/admin/updateNewsStatus",
  updateNews: "/admin/updateNews",
  viewNews: "/admin/newsDetails",
  newsDetails: "/admin/newsDetails",
  addTeam: "/admin/addTeam",
  deleteNews: "/admin/deleteNews",
  teamList: "/admin/viewTeamList",
  teamBlock: "/admin/updateTeamStatus",
  teamDelete: "/admin/deleteTeam",
  teamView: "/admin/viewTeam",
  updateTeam: "/admin/updateTeam",
  addBanner: "/admin/addBanner",
  bannerList: "/admin/bannerList",
  bannerDetails: "/admin/bannerDetails",
  updateBanner: "/admin/updateBanner",
  updatestatus: "/admin/banners/status",
  bannerUpdate: "/admin/updateBanner",
  viewBanner: "/admin/bannerList",
  deleteBanner: "/admin/banners",
  addFeaturedRestaurant: "/admin/addFeaturedRestaurant",
  cuisineList: "/admin/cuisineList",
  cuisineBlock: "/admin/updateCuisineStatus",
  addCuisine: "/admin/addCuisine",
  updateCuisine: "/admin/updateCuisine",
  dishCategoryList: "/admin/dishCategoryList",
  dishCategoryBlock: "/admin/updateDishCategoryStatus",
  dishCategoryDelete: "/admin/deleteDishCategory",
  addDishCategory: "/admin/addDishCategory",
  updateDishCategory: "/admin/updateDishCategory",
  mealTypeList: "/admin/mealTypeList",
  addMealType: "/admin/addMealType",
  updateMealType: "/admin/updateMealType",
  mealTypeStatusUpdate: "/admin/mealTypeStatusUpdate",
  customerList: "/admin/customers",
  customerStatusUpdate: "/admin/updateCustomerStatus",
  customerDetails: "/admin/customers",
  ingredientList: "/admin/ingridentList",
  ingredientStatusUpdate: "/admin/ingridentStatusUpdate",
  ingredientDelete: "/admin/deleteIngredient",
  addIngredient: "/admin/addIngrident",
  updateIngredient: "/admin/updateIngrident",
  allergiesList: "/admin/allergieList",
  addAllergies: "/admin/addAllergie",
  updateAllergies: "/admin/updateAllergie",
  allergiesStatusUpdate: "/admin/updateAllergyStatus",
  allergiesDelete: "/admin/deleteAllergy",
  restaurantList: "/admin/restaurentList",
  restaurantDetails: "/admin/restaurent",
  restaurantApprovalStatus: "/admin/restaurent",
  restaurantMenuCatalogue: "/admin/restaurent/menu-catalogue",
  menuCatalogueDetail: "/admin/restaurent/menu-catalogue-detail",
  contentManagement: "/admin/updateContentManagement",
  updateContentManagement: "/admin/updateContentManagement",
  getContent: "/admin/getContent",
  orderList: "/admin/order",
  orderDetails: "/admin/order",
  dishReviewList: "/admin/DishReviewList",
  restaurantReviewList: "/admin/restaurantReviewList",
  customerListDropdown: "/admin/customerList",
  restaurantListDropdown: "/admin/RestaurantList",
  addNotification: "/admin/addNotification",
  notificationList: "/admin/notificationList",
  variationList: "/admin/variationList",
  updateVariations: "/admin/updateVariation",
  addVariation: "/admin/addVariation",
  getGlobalParameters: "/admin/getGlobalParameter",
  getPartnerStreamList: "/admin/getPartnerStreamList",
  createPartnerStream: "/admin/createPartnerStream",
  getPartnerStream: "/admin/getPartnerStream",
  updatePartnerStream: "/admin/updatePartnerStream",
  updatePartnerStreamStatus: "/admin/updatePartnerStreamStatus",
  createCompetition: "/admin/createCompetition",
  getCompetitionList: "/admin/getCompetitionList",
  getCompetitionDetails: "/admin/getCompetition",
  updateCompetition: "/admin/updateCompetition",
  updateCompetitionStatus: "/admin/updateCompetitionStatus",
  createFormMaster: "/admin/createFormMaster",
  formMasterList: "/admin/getFormMasterList",
  getFormMasterDetails: "/admin/getFormMaster",
  updateFormMaster: "/admin/updateFormMaster",
  updateFormMasterStatus: "/admin/updateFormMasterStatus",
  deleteFormMaster: "/admin/deleteFormMaster",
  deleteFormMasterOption: "/admin/deleteFormMasterOption",
  createWinTicket: "/admin/createWinTicket",
  winTicketList: "/admin/winTicketList",
  updateWinTicket: "/admin/updateWintTicket",
  updateWinTicketStatus: "/admin/updateWinTiceketStatus",
  createQuiz: "/admin/createQuize",
  quizList: "/admin/quizeList",
  quizDetails: "/admin/quizeDetails",
  updateQuiz: "/admin/updateQuize",
  updateQuizStatus: "/admin/updateQuizeStatus",
  deleteMatch: "/admin/deleteMatch",
  createPartnerUpdate: "/admin/createPartnerUpdate",
  partnerUpdateList: "/admin/getPartnerUpdateList",
  partnerUpdateTypeList: "/admin/getPartnerUpdateTypeList",
  createPartnerUpdateType: "/admin/createPartnerUpdateType",
  updatePartnerUpdateType: "/admin/updatePartnerUpdateType",
  updatePartnerUpdateTypeStatus: "/admin/updatePartnerUpdateTypeStatus",
  partnerUpdateDetails: "/admin/getPartnerUpdate",
  updatePartnerUpdate: "/admin/updatePartnerUpdate",
  updatePartnerUpdateStatus: "/admin/updatePartnerUpdateStatus",
  deletePartnerUpdateWeekend: "/admin/deletePartnerUpdateWeekend",
  deleteNewsWeekendSchedule: "/admin/deleteNewsWeekendSchedule",
  getBookTicket: "/admin/getBookTicket",
  updateBookTicket: "/admin/updateBookTicket",
  getSoundTrack: "/admin/getSoundTrack",
  updateSoundTrack: "/admin/updateSoundTrack",
  saudiaMomentList: "/admin/saudiaMomentList",
  updateSaudiaMoment: "/admin/updateSaudiaMoment",
  createSaudiaHolidayPackage: "/admin/createSaudiaHolidayPackage",
  holidayPackageList: "/admin/holidayPackageList",
  updateSaudiaHolidayPackage: "/admin/updateSaudiaHolidayPackage",
  updateHolidayPackageStatus: "/admin/updateHolidayPackageStatus",
  createSurveyQuestion: "/admin/createSurveyQuestion",
  surveyQuestionList: "/admin/surveyQuestionList",
  surveyQuestionDetails: "/admin/surveyQuestionDetails",
  updateSurveyQuestion: "/admin/updateSurveyQuestion",
  updateSurveyQuestionStatus: "/admin/updateSurveyQuestionStatus",
  createSurvey: "/admin/createSurvey",
  surveyList: "/admin/surveyQuestionList",
  surveyDetails: "/admin/surveyQuestionDetails",
  updateSurvey: "/admin/updateSurveyQuestion",
  userSurveyList: "/admin/userSurveyList",
  userSurveyDetails: "/admin/userSurveyDetails",
  updateQuizeSurveyStatus: "/admin/updateQuizeSurveyStatus",
  getDashboardDetails: "/admin/getDashboardDetails",
  exportuserDetails:"/admin/userMatchMapping",
};
export const devAbiConfig = {};
